import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import StatusCard from "examples/Cards/StatisticsCards/StatusCard";
import { ConfigProvider, DatePicker, theme } from "antd";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const RevenueReports = () => {
  const { RangePicker } = DatePicker;
  const axiosPrivate = useAxiosPrivate();
  const [dates, setDates] = useState([dayjs().startOf("month"), dayjs().endOf("month")]);
  const [loading, setLoading] = useState();
  const [reportData, setReportData] = useState({});
  useEffect(() => {
    handleRevenueReport({
      startDate: dates[0].startOf("day").valueOf(),
      endDate: dates[1].endOf("day").valueOf(),
    });
  }, []);
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const handleRevenueReport = (params) => {
    setLoading(true);
    let urlParams = "";
    if (params) {
      Object.keys(params).forEach(function (key, index) {
        urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
      });
    }
    console.log(urlParams);
    const option = {
      url: `om/ocfSummary${urlParams}`,
      method: "get",
    };
    axiosPrivate(option)
      .then((response) => {
        console.log(response);
        setReportData(response?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  console.log(reportData);
  const skeletonArray = new Array(6).fill({});
  const statusConfig = {
    Draft: {
      color: "warning",
      icon: "edit_note",
    },
    Submitted: {
      color: "info",
      icon: "upload_file",
    },
    "Rejected by CRM": {
      color: "error",
      icon: "cancel",
    },
    Approved: {
      color: "success",
      icon: "check_circle",
    },
    Confirmed: {
      color: "primary",
      icon: "verified",
    },
    "Ready To Bill": {
      color: "secondary",
      icon: "receipt_long",
    },
    Billed: {
      color: "dark",
      icon: "payments",
    },
    Collected: {
      color: "success",
      icon: "account_balance_wallet",
    },
  };

  const handleDateChange = (dates) => {
    if (!dates) return;
    const startTime = dates[0].startOf("day").valueOf();
    const endTime = dates[1].endOf("day").valueOf();
    setDates(dates);
    handleRevenueReport({ startDate: startTime, endDate: endTime });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
          <MDBox fontWeight="bold" fontSize={24}>
            Revenue Report
          </MDBox>

          <MDBox display="flex" gap={2} flexWrap="wrap">
            <ConfigProvider
              theme={{
                algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                components: {
                  DatePicker: {
                    colorBgContainer: darkMode ? "#1a2035" : "#fff",
                    colorText: darkMode ? "#fff" : "#000",
                    colorBorder: darkMode ? "#475894" : "#d9d9d9",
                    colorBgElevated: darkMode ? "#1f2937" : "#fff",
                    colorPrimary: darkMode ? "#1890ff" : "#1890ff",
                  },
                },
              }}
            >
              <RangePicker value={dates} onChange={handleDateChange} allowClear={false} />
            </ConfigProvider>
          </MDBox>
        </MDBox>

        <Grid container spacing={3} py={4}>
          {(loading ? skeletonArray : Object.entries(reportData || {})).map((item, index) => {
            const status = loading ? null : item[0];
            const data = loading ? {} : item[1];

            const config = statusConfig[status] || {
              color: "primary",
              icon: "leaderboard",
            };

            return (
              <Grid key={status || index} item xs={12} sm={6} md={3} lg={4}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color={config.color}
                    icon={config.icon}
                    title={status || ""}
                    count={loading ? "" : `${data?.count || 0}`}
                    percentage={{ color: "success" }}
                    loading={loading}
                    text={"Total"}
                    textValue={new Intl.NumberFormat("en-IN").format(data?.netRevenue || 0)}
                    onClick={() => {
                      console.log(status);
                      if (!status) {
                        return;
                      }
                      navigate(`/otf?status=${status}`);
                    }}
                  />
                </MDBox>
              </Grid>
            );
          })}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default RevenueReports;
